import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=97aa0966&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=ts"
export * from "./InvoiceList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aa0966",
  null
  
)

export default component.exports